import _sfc_main from './toolbar-divider.vue.js';
/* empty css                     */
import _export_sfc from '../../_virtual/_plugin-vue_export-helper.js';

const toolbarDivider = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-6a21903f"]]);

export { toolbarDivider as default };
//# sourceMappingURL=toolbar-divider.js.map
